import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material'

type Props = {
  name: string
  label?: React.ReactNode
  disabled?: boolean
  readOnly?: boolean
  onChange?: (checked: boolean) => void
} & Omit<CheckboxProps, 'name' | 'onChange' | 'checked'>

/**
 * MUI Checkbox with react-hook-form
 */
const FormCheckbox: React.FC<Props> = ({ name, label, disabled = false, readOnly = false, onChange: onChangeProp, ...checkboxProps }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControlLabel
          control={
            <Checkbox
              {...field}
              {...checkboxProps}
              checked={field.value ?? false}
              onChange={(e, checked) => {
                if (readOnly) return

                field.onChange(e)
                onChangeProp?.(checked)
              }}
              disabled={disabled}
              sx={{
                cursor: readOnly ? 'not-allowed' : undefined,
                ...checkboxProps.sx,
              }}
            />
          }
          label={label}
          disabled={disabled || readOnly}
          sx={{
            color: error ? 'error.main' : undefined,
            cursor: readOnly ? 'not-allowed' : undefined,
          }}
        />
      )}
    />
  )
}

FormCheckbox.displayName = 'FormCheckbox'

export default FormCheckbox
